import PropTypes from 'prop-types'

function validateTranslation(propValue, key, componentName, location, propFullName) {
    if (!/^[a-z]{2}-[A-Z]{2}$/.test(key)) {
        return Error(`Invalid prop ${propFullName} supplied to ${componentName}. Keys should be locale strings.`)
    }

    if (typeof propValue[key] !== 'string') {
        return Error(`Invalid prop ${propFullName} supplied to ${componentName}. Translations should be strings.`)
    }
}

export const translationPropType = PropTypes.objectOf(validateTranslation)
